/* ex your Gluten -- shared behaviour for all EYG sections (home, PDP, collection).
   Included by every eyg-* section; guards itself so it only ever initialises
   once even though the <script> tag appears once per section.
   All setup waits for DOMContentLoaded (first script tag executes mid-parse).
   Reveal selectors must cover every EYG scope class (.eyg-home, .eyg-pdpx,
   .eyg-colx).
   THEME EDITOR: Shopify re-renders a section's HTML on every setting change
   (shopify:section:load) without re-running this script's init. In design
   mode all reveal states are therefore applied immediately and re-applied
   after each section re-render, so sections never appear empty while
   editing.
   WARTELISTE: form[data-wait] posts directly to Klaviyo's public Client
   Subscriptions API (no server code / no Klaviyo onsite JS needed -- that
   product moved to dashboard-managed Signup Forms which can't be styled to
   match our design). company_id is a public identifier, safe to hardcode
   (it's already exposed in every page's own Klaviyo script tag). List id is
   read per-form from data-klaviyo-list so it can be changed without code. */
(function(){
  if(window.__eygHomeInit)return;
  window.__eygHomeInit=true;

  var REVEAL_SEL='.eyg-home .reveal, .eyg-home .stag, .eyg-home .clrise, .eyg-home .mark, .eyg-pdpx .reveal, .eyg-pdpx .mark, .eyg-colx .reveal, .eyg-colx .mark';
  var KLAVIYO_COMPANY_ID='QUUgKA';
  var KLAVIYO_DEFAULT_LIST='TvZHef';

  function forceVisible(scope){
    [].slice.call(scope.querySelectorAll(REVEAL_SEL)).forEach(function(el){el.classList.add('in');});
    if(scope.matches&&scope.matches(REVEAL_SEL))scope.classList.add('in');
    [].slice.call(scope.querySelectorAll('.eyg-pack .drop')).forEach(function(el){el.style.opacity=1;el.style.transform='translate(-50%,-50%)';});
    [].slice.call(scope.querySelectorAll('[data-eyg-typed] .tword')).forEach(function(el,i){el.classList.toggle('show',i===0);});
  }

  function init(){

  var design=window.Shopify&&window.Shopify.designMode;

  // ---- Waitlist toast, shared by every signup form on the page (errors + validation only; success redirects) ----
  var toast=document.getElementById('eyg-home-toast');
  if(!toast){
    toast=document.createElement('div');
    toast.className='eyg-home-toast';
    toast.id='eyg-home-toast';
    toast.innerHTML='<svg viewBox="0 0 24 24"><path d="M5 12l5 5L20 6"/></svg><span id="eyg-home-toast-text"></span>';
    toast.querySelector('#eyg-home-toast-text').textContent=(window.eygT&&window.eygT.home_waitlist_ok)||'Du stehst auf der Liste.';
    document.body.appendChild(toast);
  }
  var toastText=document.getElementById('eyg-home-toast-text');
  var toastTimer;
  function showToast(msg){
    toastText.textContent=msg;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer=setTimeout(function(){toast.classList.remove('show');},3400);
  }
  document.querySelectorAll('form[data-wait]').forEach(function(f){
    if(f.dataset.eygBound)return;
    f.dataset.eygBound='1';
    var btn=f.querySelector('button[type=submit]');
    var btnLabel=btn?btn.textContent:'';
    f.addEventListener('submit',function(e){
      e.preventDefault();
      if(design){showToast((window.eygT&&window.eygT.home_waitlist_preview)||'Vorschau: Anmeldung wird im Live-Theme wirklich gesendet.');return;}
      var inp=f.querySelector('input[type=email]');
      var email=inp?inp.value.trim():'';
      if(!email){showToast((window.eygT&&window.eygT.home_waitlist_email_missing)||'Bitte gib deine E-Mail ein.');return;}
      var listId=f.dataset.klaviyoList||KLAVIYO_DEFAULT_LIST;
      if(btn){btn.disabled=true;btn.textContent=(window.eygT&&window.eygT.home_waitlist_sending)||'Einen Moment ...';}  
      fetch('https://a.klaviyo.com/client/profiles/?company_id='+KLAVIYO_COMPANY_ID,{method:'POST',keepalive:true,headers:{'Content-Type':'application/json','revision':'2025-07-15'},body:JSON.stringify({data:{type:'profile',attributes:{email:email,properties:{waitlist_source:(f.dataset.source||location.pathname),waitlist_country:((window.Shopify&&window.Shopify.country)||'')}}}})}).catch(function(){});
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+KLAVIYO_COMPANY_ID,{
        method:'POST',
        headers:{'Content-Type':'application/json','revision':'2025-07-15'},
        body:JSON.stringify({
          data:{
            type:'subscription',
            attributes:{
              custom_source:(f.dataset.source||(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/?)?$/i.test(location.pathname)?'Homepage Waitlist Form':'Waitlist '+location.pathname)),
              profile:{
                data:{
                  type:'profile',
                  attributes:{
                    email:email,
                    subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}}
                  }
                }
              }
            },
            relationships:{list:{data:{type:'list',id:listId}}}
          }
        })
      })
      .then(function(r){
        if(r.ok||r.status===202){window.location.href=((window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/').replace(/\/?$/,'/')+'pages/warteliste-danke';}
        else{throw new Error('subscribe_failed');}
      })
      .catch(function(){
        showToast((window.eygT&&window.eygT.home_waitlist_error)||'Etwas ist schiefgelaufen. Versuch es gleich noch mal.');
        if(btn){btn.disabled=false;btn.textContent=btnLabel;}
      });
    });
  });

  // ---- Theme editor: everything visible, immediately and after re-renders ----
  if(design){
    forceVisible(document);
    document.addEventListener('shopify:section:load',function(e){forceVisible(e.target);});
    document.addEventListener('shopify:block:select',function(e){forceVisible(e.target);});
  }else{
    // ---- Reveal-on-scroll (all EYG scopes) ----
    var revealEls=[].slice.call(document.querySelectorAll(REVEAL_SEL));
    var io=new IntersectionObserver(function(es){
      es.forEach(function(en){if(en.isIntersecting){en.target.classList.add('in');io.unobserve(en.target);}});
    },{threshold:.12});
    revealEls.forEach(function(el){io.observe(el);});
    revealEls.forEach(function(el){
      var r=el.getBoundingClientRect();
      if(r.top<innerHeight&&r.bottom>0){el.classList.add('in');io.unobserve(el);}
    });
  }

  // ---- Horizontally scrollable tables: swipe hint + edge fade ----
  document.querySelectorAll('.eyg-tblwrap').forEach(function(wrap){
    var sc=wrap.querySelector('.tbl-scroll');
    if(!sc)return;
    function chk(){
      if(sc.scrollWidth>sc.clientWidth+4){wrap.classList.add('has-scroll');}
      else{wrap.classList.remove('has-scroll');}
    }
    chk();
    window.addEventListener('resize',chk);
    sc.addEventListener('scroll',function(){
      if(sc.scrollLeft>16)wrap.classList.add('scrolled');
    },{passive:true});
  });

  // ---- Typed / rotating headline word ----
  document.querySelectorAll('[data-eyg-typed]').forEach(function(typedLine){
    var tWords=[].slice.call(typedLine.querySelectorAll('.tword'));
    var heroH1=typedLine.closest('h1');
    // Seit 09.10.2026 auch nach dem Laden der Schriften neu messen: vorher wurde mit der
    // Ersatzschrift gemessen und das Wort blieb danach zu klein oder abgeschnitten.
    function fitWords(){
      if(!heroH1||!tWords.length)return;
      var maxW=heroH1.clientWidth;
      if(!maxW)return;
      tWords.forEach(function(el){
        var prevVis=el.style.visibility,prevClip=el.style.clipPath;
        el.style.fontSize='';
        el.style.visibility='hidden';el.style.clipPath='none';
        var w=el.scrollWidth;
        if(w>maxW&&w>0){el.style.fontSize=(maxW/w*0.96)+'em';}
        el.style.visibility=prevVis;el.style.clipPath=prevClip;
      });
    }
    fitWords();
    if(document.fonts&&document.fonts.ready){document.fonts.ready.then(fitWords);}
    window.addEventListener('load',fitWords);
    window.addEventListener('resize',fitWords);
    var reduceT=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(reduceT||tWords.length<2){
      tWords.forEach(function(el,i){el.classList.toggle('show',i===0);});
      return;
    }
    var idx=0;
    setInterval(function(){
      tWords[idx].classList.remove('show');
      var nextIdx=(idx+1)%tWords.length;
      setTimeout(function(){tWords[nextIdx].classList.add('show');idx=nextIdx;},550);
    },3000);
  });

  // ---- Scroll-driven pack-fill animation (one instance per .eyg-pack section) ----
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function ease(t){return 1-Math.pow(1-t,3);}
  function place(el,e){
    var sx=+el.dataset.sx,rot=+el.dataset.rot;
    var x=sx*(1-e);
    var y=-560*(1-e);
    var sc=1.18-0.34*e;
    var r=rot*(1-e);
    el.style.transform='translate(calc(-50% + '+x+'px), calc(-50% + '+y+'px)) rotate('+r+'deg) scale('+sc+')';
  }
  document.querySelectorAll('.eyg-pack').forEach(function(pack){
    var drops=[].slice.call(pack.querySelectorAll('.drop'));
    if(!drops.length)return;
    if(design){drops.forEach(function(el){place(el,1);el.style.opacity=1;});return;}
    var win=parseFloat(pack.dataset.window);
    if(!win||win<=0)win=0.34;
    function fill(){
      var rect=pack.getBoundingClientRect();
      var total=pack.offsetHeight-window.innerHeight;
      var p=Math.min(1,Math.max(0,(-rect.top)/(total||1)));
      drops.forEach(function(el){
        var d=parseFloat(el.dataset.d)||0;
        var lp=Math.min(1,Math.max(0,(p-d)/win));
        place(el,ease(lp));
        el.style.opacity=Math.min(1,lp*4);
      });
    }
    // Seit 09.10.2026: Bei "Bewegung reduzieren" liegen die Produkte nicht unsichtbar mittig hinter der
    // Box, sondern schauen links, rechts und oben leicht hinter ihr hervor.
    function peek(){
      var box=pack.querySelector('.pack-box');
      var br=box?box.getBoundingClientRect():{width:300,height:220};
      var spots=[[-1,-0.06,-14],[1,0.04,12],[0,-0.36,-5]];
      drops.forEach(function(el,i){
        var s=spots[i%spots.length];
        var dw=el.offsetWidth||120;
        var x=s[0]*(br.width/2-dw*0.05), y=s[1]*br.height;
        el.style.transform='translate(calc(-50% + '+x+'px), calc(-50% + '+y+'px)) rotate('+s[2]+'deg) scale(.82)';
        el.style.opacity=1;
      });
    }
    window.__eygPackPeek=peek;
    if(reduce){peek();window.addEventListener('load',peek);window.addEventListener('resize',peek);return;}
    var tick=false;
    function onScroll(){if(!tick){tick=true;requestAnimationFrame(function(){fill();tick=false;});}}
    // Seit 09.10.2026: Scroll-Ereignisse im Capture-Modus am Dokument abhoeren. So laeuft die
    // Animation auch, wenn nicht das Fenster scrollt (In-App-Browser, iOS-Sonderfaelle).
    window.addEventListener('scroll',onScroll,{passive:true});
    document.addEventListener('scroll',onScroll,{passive:true,capture:true});
    window.addEventListener('touchmove',onScroll,{passive:true});
    window.addEventListener('resize',fill);
    window.addEventListener('load',fill);
    fill();
    // Seit 09.10.2026: Solange die Section im Bild ist, rechnet eine Bildschleife die Position
    // laufend nach. So haengt die Animation nicht mehr davon ab, dass der Browser Scroll-Ereignisse
    // meldet (iOS Safari lieferte sie in einigen Faellen nicht). Ausserhalb des Bildes steht sie still.
    if('IntersectionObserver' in window){
      var looping=false,visible=false;
      function loop(){if(!visible){looping=false;return;}fill();requestAnimationFrame(loop);}
      new IntersectionObserver(function(es){
        visible=es[0].isIntersecting;
        if(visible&&!looping){looping=true;requestAnimationFrame(loop);}
      }).observe(pack);
    }
  });

  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',init);
  }else{
    init();
  }
})();
